define.alias("ember-intl/helpers/format-number", "media/helpers/format-number");